import { Flex } from "@radix-ui/themes";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { Wallet } from "@components/ConnectWalletDialogs/Wallet";
import { MobileMenu } from "@components/MobileMenu";

import Logo from "@assets/logo.svg?react";

import { useMedia } from "@hooks/useMedia";
import { useStores } from "@stores";
import { DIALOG_TYPE } from "@stores/DialogStore";

import { IS_APTOS_MAINNET } from "@constants";
import { Button, TabsLink, Text } from "@src/ui-kit";

const DepositButton = observer(() => {
  const { t } = useTranslation();
  const { dialogStore, accountStore } = useStores();

  if (!accountStore.isAuthenticated) return null;

  return (
    <Button
      data-testid="app:header:deposit-withdraw"
      variant="solid"
      onClick={() => dialogStore.open(DIALOG_TYPE.DEPOSIT)}
    >
      <Text font="button">{t("header.depositWithdraw")}</Text>
    </Button>
  );
});

const GetTestTokensButton = observer(() => {
  const { t } = useTranslation();
  const { accountStore, balanceStore } = useStores();

  if (IS_APTOS_MAINNET) return null;

  if (!accountStore.isAuthenticated) return null;

  const handleGetTestTokens = () => {
    balanceStore.getTestTokens();
  };

  return (
    <Button
      data-testid="app:header:get-test-tokens"
      loading={balanceStore.isTestTokensRequested}
      variant="solid"
      onClick={handleGetTestTokens}
    >
      <Text font="button">{t("header.getTestTokens")}</Text>
    </Button>
  );
});

// Header без styled компонентов — использует CSS класс из global.css
export const Header: React.FC = () => {
  const { desktop } = useMedia();

  return (
    <header className="header-root" data-testid="app:header">
      <Flex align="center" gap="24px">
        <Link
          data-testid="app:header:logo"
          aria-label="Home page"
          aria-current="page"
          rel="home"
          to="/"
          style={{ display: "flex", alignItems: "center" }}
        >
          <Logo />
        </Link>
        {desktop && <TabsLink />}
      </Flex>
      <Flex align="center" gap="10px">
        {desktop && <GetTestTokensButton />}
        {desktop && <DepositButton />}
        <Wallet />
        {!desktop && <MobileMenu />}
      </Flex>
    </header>
  );
};
